const list = [
  {
    name: '用户管理',
    menuItem: {
      name: '用户管理',
      iconClass: '',
      route: '/user-management'
    }
  },
  {
    name: '企业管理',
    menuItem: {
      name: '企业管理',
      iconClass: '',
      route: '/company-management'
    }
  },
  {
    name: '停车管理',
    menuItem: {
      name: '停车管理',
      iconClass: '',
      route: '/park-management'
    }
  },
  {
    name: '停车记录',
    menuItem: {
      name: '停车记录',
      route: '/park-management/park-log-management'
    }
  },
  {
    name: '停车券管理',
    menuItem: {
      name: '停车券管理',
      route: '/park-management/park-coupon-management'
    }
  },
  {
    name: '会议室管理',
    menuItem: {
      name: '会议室管理',
      iconClass: '',
      route: '/metting-management'
    }
  },
  {
    name: '会议室列表',
    menuItem: {
      name: '会议室列表',
      route: '/metting-management/list-management'
    }
  },
  {
    name: '预约管理',
    menuItem: {
      name: '预约管理',
      route: '/metting-management/appointment-management'
    }
  },
  {
    name: '电子放行管理',
    menuItem: {
      name: '电子放行管理',
      route: '/electronic-management'
    }
  },
  {
    name: '企业服务管理',
    menuItem: {
      name: '企业服务管理',
      iconClass: '',
      route: '/serve-management'
    }
  },
  {
    name: '企业分类管理',
    menuItem: {
      name: '企业分类管理',
      route: '/serve-management/classify-management'
    }
  },
  {
    name: '服务管理',
    menuItem: {
      name: '服务管理',
      route: '/serve-management/serve-management-management'
    }
  },
  {
    name: '意向留言列表',
    menuItem: {
      name: '意向留言列表',
      route: '/serve-management/message-management'
    }
  },
  {
    name: '内容管理',
    menuItem: {
      name: '内容管理',
      iconClass: '',
      route: '/basic-management'
    }
  },
  {
    name: '轮播图管理',
    menuItem: {
      name: '轮播图管理',
      iconClass: '',
      route: '/basic-management/carousel'
    }
  },
  {
    name: '资讯管理',
    menuItem: {
      name: '资讯管理',
      iconClass: '',
      route: '/basic-management/consult-list'
    }
  },
  {
    name: '权限管理',
    menuItem: {
      name: '权限管理',
      iconClass: '',
      route: '/authority-management'
    }
  },
  {
    name: '菜单管理',
    menuItem: {
      name: '菜单管理',
      route: '/authority-management/menu'
    }
  },
  {
    name: '管理员列表',
    menuItem: {
      name: '管理员列表',
      route: '/authority-management/admin-management'
    }
  },
  {
    name: '身份管理',
    menuItem: {
      name: '身份管理',
      route: '/authority-management/identity-management'
    }
  },
  {
    name: '操作日志',
    menuItem: {
      name: '操作日志',
      route: '/authority-management/log-management'
    }
  },
  {
    name: '通知管理',
    menuItem: {
      name: '通知管理',
      route: '/notice-list'
    }
  },
  {
    name: '分类管理',
    menuItem: {
      name: '分类管理',
      route: '/classify-list'
    }
  },
  {
    name: '产业管理',
    menuItem: {
      name: '产业管理',
      route: '/industry-management'
    }
  },
  {
    name: '精选项目管理',
    menuItem: {
      name: '精选项目管理',
      route: '/featured-management'
    }
  },
  {
    name: '精选项目列表',
    menuItem: {
      name: '精选项目列表',
      route: '/project-list'
    }
  },
  {
    name: '房源列表',
    menuItem: {
      name: '房源列表',
      route: '/house-list'
    }
  },
  {
    name: '精选项目标签',
    menuItem: {
      name: '精选项目标签',
      route: '/project-tag-list'
    }
  },
  {
    name: '云空间管理',
    menuItem: {
      name: '云空间管理',
      route: '/cloud-list'
    }
  },
  {
    name: '投诉报修管理',
    menuItem: {
      name: '投诉报修管理',
      iconClass: '',
      route: '/complaint'
    }
  },
  {
    name: '投诉建议列表',
    menuItem: {
      name: '投诉建议列表',
      route: '/complaint/suggesstion'
    }
  },
  {
    name: '在线报修列表',
    menuItem: {
      name: '在线报修列表',
      route: '/complaint/repair'
    }
  },
]

const mapper = new Map()
list.forEach((value) => {
  mapper.set(value.name, value.menuItem)
})

export default mapper
